import {aGenericError} from '@modifi/redux'
import {createSelector} from 'reselect'
import {getAuthenticatedAdminAresClient} from '@modifi/trade-api-clients'

const ACTION_UNLINK_DOCUMENT_FROM_TRANSACTION_PENDING =
  'order-details/payment/UNLINK_DOCUMENT_PENDING'
const ACTION_UNLINK_DOCUMENT_FROM_TRANSACTION_SUCCESS =
  'order-details/payment/UNLINK_DOCUMENT_SUCCESS'
const ACTION_UNLINK_DOCUMENT_FROM_TRANSACTION_ERROR = 'order-details/payment/UNLINK_DOCUMENT_ERROR'
const ACTION_UNLINK_DOCUMENTS_TO_TRANSACTION_CLEANUP =
  'order-details/documents/UNLINK_DOCUMENTS_TO_TRANSACTION_CLEANUP'

const initialState = {
  inProgress: false,
  error: false,
  errorMessage: null,
  errorCode: null,
}

export default (state = initialState, {type, payload}) => {
  switch (type) {
    case ACTION_UNLINK_DOCUMENT_FROM_TRANSACTION_PENDING: {
      return {
        ...state,
        inProgress: true,
        error: false,
        errorMessage: null,
        errorCode: null,
      }
    }
    case ACTION_UNLINK_DOCUMENT_FROM_TRANSACTION_SUCCESS: {
      return {
        ...initialState,
      }
    }
    case ACTION_UNLINK_DOCUMENT_FROM_TRANSACTION_ERROR: {
      const {message, code} = payload
      return {
        ...state,
        inProgress: false,
        error: true,
        errorMessage: message,
        errorCode: code,
      }
    }
    case ACTION_UNLINK_DOCUMENTS_TO_TRANSACTION_CLEANUP: {
      return {
        ...initialState,
      }
    }
    default:
      return state
  }
}

const baseSelector = state => state.modules.unlink
export const selectIsUnlinkDocumentsFromTransactionInProgress = createSelector(
  baseSelector,
  unlink => unlink.inProgress
)
export const selectIsUnlinkDocumentsFromTransactionError = createSelector(
  baseSelector,
  unlink => unlink.error
)
export const selectUnlinkDocumentsFromTransactionErrorMessage = createSelector(
  baseSelector,
  unlink => unlink.errorMessage
)

const sendUnlinkDocumentFromTransactionRequest = (transactionId, fileId) => {
  const client = getAuthenticatedAdminAresClient()
  return client.BankTransactions.deleteDocument({
    transactionId,
    fileId,
  }).then(res => res.data())
}

export const aUnlinkDocumentFromTransaction = (orderId, paymentId, fileId) => async dispatch => {
  dispatch({
    type: ACTION_UNLINK_DOCUMENT_FROM_TRANSACTION_PENDING,
  })

  try {
    await sendUnlinkDocumentFromTransactionRequest(orderId, paymentId, fileId)
  } catch (error) {
    const errorAction = aGenericError(ACTION_UNLINK_DOCUMENT_FROM_TRANSACTION_ERROR, error)
    if (errorAction.payload?.code !== 404) {
      // swallow 404 errors since we want to delete the ref and 404 indicates it is deleted already
      dispatch(errorAction)

      throw new Error(errorAction.payload.message || 'Internal Error')
    }
  }

  dispatch({
    type: ACTION_UNLINK_DOCUMENT_FROM_TRANSACTION_SUCCESS,
  })
  return true
}

export const aUnlinkDocumentToTransactionCleanup = () => ({
  type: ACTION_UNLINK_DOCUMENTS_TO_TRANSACTION_CLEANUP,
})
